import { PaletteMode } from '@mui/material';
import { createContext } from 'react';
export const ThemeContext = createContext({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  toggleMode: () => {},
  // eslint-disable-next-line
  selectMode: (mode: PaletteMode) => {}
});

